import { render, staticRenderFns } from "./i-nav-items.vue?vue&type=template&id=1215048e&scoped=true&"
import script from "./i-nav-items.vue?vue&type=script&lang=js&"
export * from "./i-nav-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215048e",
  null
  
)

export default component.exports